import { FC } from 'react';
import styled from 'styled-components';

interface CheckboxProps {
  checked: boolean;
  onChange: () => void;
  text?: string;
}

const Root = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 8px;
`;

const Box = styled.div<{ $checked: boolean }>`
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 1px solid
    ${({ $checked }) => ($checked ? 'rgba(155, 89, 182, 0.8)' : 'rgba(255, 255, 255, 0.25)')};
  background: ${({ $checked }) =>
    $checked ? 'rgba(155, 89, 182, 0.4)' : 'rgba(255, 255, 255, 0.05)'};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;
  font-size: 11px;
  color: #fff;
`;

const Text = styled.span`
  font-family: 'Share Tech Mono', monospace;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
`;

export const Checkbox: FC<CheckboxProps> = ({ checked, onChange, text }) => (
  <Root onClick={onChange}>
    <Box $checked={checked}>{checked ? '✓' : ''}</Box>
    {text && <Text>{text}</Text>}
  </Root>
);
